// extracted by mini-css-extract-plugin
export default {"container":"Collapsible_container__BfMrL","header":"Collapsible_header__ITJ1g","body":"Collapsible_body__4zgb2"};